import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import 'components/DatePickerInput/normalizeDatePicker.css';
import { t } from 'locales/i18n';

interface DatePickerInputProps {
  value: string;
  onChange: (date: Date) => void;
  id?: string;
}

const DatePickerInput = ({ value, onChange, id }: DatePickerInputProps) => {
  const selectedDate = value ? new Date(value) : null;

  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat="yyyy-MM-dd h:mm aa"
        timeInputLabel={t('Time:')}
        showTimeInput
        id={id}
        placeholderText={t('Select a date')}
      />
    </div>
  );
};

export default DatePickerInput;
